/*!
  Pioneer WFRIA DateUtils v4.0.0-beta.53
  © 2023 Wells Fargo. All rights reserved.
*/
try {
  if (!window.__PIONEER_GLOBAL__) {
    window.__PIONEER_GLOBAL__ = {
      version: "4.0.0-beta.53",
      components: ["DateUtils"]
    };
  } else if (window.__PIONEER_GLOBAL__.components && window.__PIONEER_GLOBAL__.components.indexOf("DateUtils") < 0) {
    window.__PIONEER_GLOBAL__.components.push("DateUtils");
  }
} catch (error) {
  // catching server side rendering issues - windows is not defined there!
}

/**
 * This file has been downloaded from https://github.com/gpbl/react-day-picker
 * We are using it under the MIT license and will modify it as needed.
 */

/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */
export function isDate(value) {
  return value instanceof Date && !isNaN(value.valueOf());
}
/**
 * Accepts a number and adds a leading zero to it when the value
 * is a single digit.
 *
 * Note: This utility has been created by the WRIA team.
 *
 * @param {Number} value Number to which a leading zero should be added.
 * @returns {String} Returns a string with a leading zero if value is
 *                   a single digit.
 */

export function addLeadingZero(value) {
  return value.toString().length > 1 ? value : `0${value}`;
}
export default {
  addLeadingZero,
  isDate
};